import { SET_USER, SET_ISLOGGED_IN, SET_CHARACTER, CLEAR_DATA } from './types.js'
import axios from 'axios'

export default {
    updateUserIsLoggedIn({ commit }, payload) {
        commit(SET_ISLOGGED_IN, payload)
    },
    setUserData({ commit }, payload) {
        commit(SET_USER, payload)
    },
    setCharacters({ commit }, payload) {
        commit(SET_CHARACTER, payload)
    },
    setShopLogs({ commit }, payload) {
        commit(SET_CHARACTER, payload)
    },
    clearData({ commit }) {
        commit(CLEAR_DATA)
    },
    async getAuthUser (state) {
      const user = await axios.get('/api/user')
        .then(async response => {
            state.dispatch('updateUserIsLoggedIn', true)
            state.dispatch('setUserData', response.data.data)
            state.dispatch('setCharacters', response.data.data.characters)
            return Promise.resolve(response)
        })
        .catch(async error => {
            state.dispatch('updateUserIsLoggedIn', false)
            state.dispatch('setUserData', null)
            state.dispatch('setCharacters', null)
            state.dispatch('clearData')
            localStorage.clear();
            return Promise.reject(error)
        })

        return user
    },
    async logout (state) {
        const user = await axios.get('/api/logout')
          .then(async response => {
            await state.dispatch('updateUserIsLoggedIn', false)
            await state.dispatch('setUserData', null)
            await state.dispatch('setCharacters', null)
            await state.dispatch('clearData')
            localStorage.clear();
            return Promise.resolve(response)
          })
          .catch(async error => {
            await state.dispatch('updateUserIsLoggedIn', false)
            await state.dispatch('setUserData', null)
            await state.dispatch('setCharacters', null)
            await state.dispatch('clearData')
            await localStorage.clear();
            return Promise.reject(error)
          })
  
          return user
    },
    async changePassword(context, parameters) {
        return await axios.post('api/user/change-password', parameters)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async changeEmail(context, parameters) {
        return await axios.post('api/user/change-email', parameters)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async changePin(context, parameters) {
        return await axios.post('api/user/change-pin', parameters)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async topup(context, parameters) {
        return await axios.post('api/user/topup', parameters)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async shopLogs(context, parameters) {
        return await axios.get('api/user/shop-logs', parameters)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async createTicket(context, parameters) {
        return await axios.post('api/user/create-ticket', parameters)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async getTickets(context, parameters) {
        return await axios.get('api/user/tickets', parameters)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async getTicketById(context, id) {
        return await axios.get(`api/ticket/${id}`)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async processTicket(context, parameters) {
        return await axios.post(`api/ticket/process`, parameters)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async generateNightMarket() {
        return await axios.get(`api/user/night-market`)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async createNightMarket(context, parameter) {
        return await axios.post(`api/user/night-market/create`, parameter)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async disableCurrentNightMarket() {
        return await axios.get(`api/user/night-market/disable`)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async userList(context, parameter) {
        return await axios.get(`api/user/list`, parameter)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async topupLogs(context, parameter) {
        return await axios.get(`api/user/topup/logs`, parameter)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async payCommission(context, parameter) {
        return await axios.post(`api/user/topup/logs/pay`, parameter)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async requestUserByID(context, userNum) {
        return await axios.get(`api/user/details/${userNum}`)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async requestUpdateUser(context, parameters) {
        const parameter = {
            ReferralCode: parameters.ReferralCode,
            UserBlock: parameters.UserBlock,
            UserLoginState: parameters.UserLoginState,
            UserType: parameters.UserType
        }

        return await axios.post(`api/user/details/${parameters.UserNum}`, parameter)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async requestUserCheckByUserName(context, UserId) {
        return await axios.get(`api/user/check/${UserId}`)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async requestSendItemToAll(context, parameter) {
        return await axios.post(`api/user/send/item`, parameter)
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    async requestCheckTopupStatus(context, parameter) {
        return await axios.get(`api/magpie/jeiurhbvprhnv/${parameter.status}`,
            { 
                params: {
                    session_id: parameter.session_id,
                    ref: parameter.ref
                }
            }
        )
            .then(response=> {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    }
}